'use client';

import { useEffect } from 'react';
import { type GtmEvent, gtmDataLayerEvent } from '~/utils/gtm/gtm-helpers';

export type GtmEventComponentProps = {
  event: GtmEvent;
};

export function GtmEventComponent(props: GtmEventComponentProps) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      gtmDataLayerEvent(props.event);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
